export default {
    namespaced: true,
    state: {
        isStop: false, // 是否停用
        channelData:null,
        isLogin: false, // 是否需登录
        channelCode:'', // 渠道id
    },
    mutations: {
        setChannelCode(state, channelCode) {
            state.channelCode = channelCode;
        },
        setIsLogin(state, isLogin) {
            state.isLogin = isLogin;
        },
        setChannelData(state, channelData) {
            state.channelData = channelData;
        },
        setIsStop(state, isStop) {
            state.isStop = isStop;
        },
    },
};